import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger' | 'solid' | 'outline';
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({ variant = 'primary', children, className, ...props }) => {
  const baseStyle = "px-4 py-2 rounded-md font-semibold text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors duration-150 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed";

  let variantStyle = '';
  switch (variant) {
    case 'primary':
      variantStyle = 'bg-[var(--color-primary)] text-white hover:brightness-[.85] focus:ring-[var(--color-primary)]';
      break;
    case 'secondary':
      // Assuming accent color is light enough for black text. If not, text color should be dynamic too.
      variantStyle = 'bg-[var(--color-accent)] text-black hover:brightness-[.85] focus:ring-[var(--color-accent)]';
      break;
    case 'ghost':
      variantStyle = 'bg-transparent text-slate-700 hover:bg-[var(--color-primary)] hover:bg-opacity-10 hover:text-[var(--color-primary)] focus:ring-[var(--color-primary)]';
      break;
    case 'danger':
      variantStyle = 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500';
      break;
    case 'solid': // For active filter style / prominent actions
      variantStyle = 'bg-[var(--color-primary)] text-white hover:brightness-[.85] focus:ring-[var(--color-primary)]';
      break;
    case 'outline':
      variantStyle = 'border border-[var(--color-primary)] text-[var(--color-primary)] hover:bg-[var(--color-primary)] hover:bg-opacity-10 focus:ring-[var(--color-primary)]';
      break;
    default: // Default to primary
      variantStyle = 'bg-[var(--color-primary)] text-white hover:brightness-[.85] focus:ring-[var(--color-primary)]';
      break;
  }

  return (
    <button
      type="button"
      className={`${baseStyle} ${variantStyle} ${className || ''}`}
      {...props}
    >
      {children}
    </button>
  );
};